import "./contact.css";
import { MdOutlineEmail } from "react-icons/md";
import { RiMessengerLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
const Contact = () => {
  // const sendEmail = (e: React.MouseEvent<HTMLButtonElement>) => {
  //   e.preventDefault();
  // };
  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact-container">
        <div className="contact-options">
          <article className="contact-option">
            <MdOutlineEmail className="contact-option-icon" />
            <h4>Email</h4>
            <h5>eng.mhajj@gmail.com</h5>
            <a
              href="mailto:eng.mhajj@gmail.com?subject='Hello from SophieCode!'&body='How can I help you'"
              title="mail"
              target="_blank"
              rel="noopener noreferrer"
            >
              Send email
            </a>
          </article>
          <article className="contact-option">
            <RiMessengerLine className="contact-option-icon" />
            <h4>Messenger</h4>
            <h5>eng.mhajj@gmail.com</h5>
            <a
              href="https://m.me/100092407891758"
              title="mail"
              target="_blank"
              rel="noopener noreferrer"
            >
              Send a message
            </a>
          </article>
          <article className="contact-option">
            <FaWhatsapp className="contact-option-icon" />
            <h4>Whatsapp</h4>
            <h5>SophieCoding</h5>
            <a
              href="https://api.whatsapp.com/send?phone=96171400777"
              title="mail"
              target="_blank"
              rel="noopener noreferrer"
            >
              Send a message
            </a>
          </article>
        </div>
        <form action="">
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea
            name="message"
            rows={7}
            placeholder="Your Message"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};
export default Contact;
